// If someone we get something like 100.50 -> 100.99 we round to 100 instead of 101. Otherwise round normally
export const roundBudget = (number) =>
  number % 10 < 1 ? Math.floor(number) : Math.round(number)

export const calculateBudgetFromRoleMinutesAndRate = (
  roleMinutes: number,
  roleRate: number,
): number =>
  roleMinutes ? roundBudget((roleMinutes / 60) * Number(roleRate)) : 0
